import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'TileError',
  props: {
    errorMessage: null,
    canSeeDetails: { type: Boolean }
  },
  emits: ["dismiss", "restart", "see-details"],
  setup(__props: any) {




return { __sfc: true, }
}

})